// @ts-nocheck - untyped
export const useApi: typeof useFetch = (url, opts?) => {
  const config = useRuntimeConfig()

  return useFetch(url, {
    baseURL: config.public.baseURL,
    credentials: 'include',

    onRequest({ options }) {
      options.headers = setupHeaders(options.headers)
    },

    onResponseError({ response }) {
      if ([404, 500].includes(response.status)) {
        showError({
          // @ts-expect-error - response._data is not typed
          message: response._data?.detail ?? 'Unknown error',
          status: response.status,
        })
        return
      }
    },

    ...opts,
  })
}
